/* src/app/controls/file-upload/file-uploader/file-uploader.component.css */
.dropzone {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100px;
  width: 550px;
  border: 2px dotted #ccc;
  background: rgb(255, 255, 255);
  color: rgb(8, 73, 16);
  position: relative;
}
.dropzone.hovering {
  border: 3px dotted #2465f1;
}
.dropzone.error {
  border: 3px dotted var(--danger);
}
/*# sourceMappingURL=file-uploader.component.css.map */
